/*
 * @param {SearcherResult} content
 * @return {SelectableListItem}
 */
export function SearcherSelectionItemMapper({ entity }) {
  return {
    id: entity.id,
    type: `message.board.type.${entity.type}`,
    title: entity.title,
    entity,
  };
}

export default {
  SearcherSelectionItemMapper,
};
